// extracted by mini-css-extract-plugin
export default {"wrapper":"heading_wrapper__iImof","heading":"heading_heading__Xr81l","subheading":"heading_subheading__1JSgf"};